export default {
  ADD_PRODUCT (state, product) {
    state.products.unshift(product)
  },
  SET_PRODUCTS (state, products) {
    state.products = products
  },
  UPDATE_PRODUCT (state, product) {
    const productIndex = state.products.findIndex((p) => p._id === product._id)
    Object.assign(state.products[productIndex], product)
  },
  REMOVE_PRODUCT (state, productId) {
    const productIndex = state.products.findIndex((p) => p._id === productId)
    state.products.splice(productIndex, 1)
  },
  UPDATE_INVENTORY (state, product) {
    const productIndex = state.products.findIndex((p) => p._id === product._id)
    Object.assign(state.products[productIndex], product)
  },
  SET_COURSELIST (state, courseList) {
    state.courseList = courseList
  }
}
